package model

import org.w3c.xhr.XMLHttpRequest
import utils.*

open class Logon {
    var G1 = ""
    var G2 = ""
    var G3 = ""
    var G4 = ""
    var G5 = ""
    var G6 = ""
    var G7 = ""
    var G8 = "" //não utilizado
    var G9 = ""
    var aaGenericoEmp: ArrayList<aaGenericoEmp>? = null //MutableList<aaGenericoEmp> = ArrayList()

    fun ini(
        G1: String, G2: String, G3: String, G4: String, G5: String, G6: String, G7: String,
        aaGenericoEmp: ArrayList<aaGenericoEmp>?
    ): Logon {

        //this.G1 = G1.ffVss()?:"teste"
        this.G1 = G1.ffVss()
        this.G2 = G2.ffVss()
        this.G3 = G3.ffVss()
        this.G4 = G4.ffVss()
        this.G5 = G5.ffVss()
        this.G6 = G6.ffVss()
        this.G7 = G7.ffVss()
        this.G8 = G8.ffVss()
        this.G9 = G9.ffVss()
        this.aaGenericoEmp = aaGenericoEmp
        return this
    }

    fun valid(obj: Logon): Logon {

        this.G1 = obj.G1.ffVss()
        this.G2 = obj.G2.ffVss()
        this.G3 = obj.G3.ffVss()
        this.G4 = obj.G4.ffVss()
        this.G5 = obj.G5.ffVss()
        this.G6 = obj.G6.ffVss()
        this.G7 = obj.G7.ffVss()
        this.G8 = obj.G8.ffVss()
        this.G9 = obj.G9.ffVss()
        return this
    }

    /*
        fun construtorLista(_it: XMLHttpRequest): List<Empresa> {

        var iLinha = 0
        val lObj = ArrayList<Empresa>()

        if ((!_it.responseText.equals(null)) && (!_it.responseText.equals(""))) {

            val lista = JSON.parse<Array<dynamic>>(_it.responseText)
            //val lista: ArrayList<Empresa> = JSON.parse<Array<Empresa>>(_it.responseText) antes dessa forma já funcionava
            //val lista1: ArrayList<Empresa> = lista.toMutableList() as ArrayList<Empresa>

            //for (obj in lista) {
            lista.forEach {

                val o = Empresa()
                o.ID_EMPRESA   =  it.ID_EMPRESA.toString().ffVsi()
                o.EMP_NOME = it.EMP_NOME.toString()
                o.EMP_NRSERIE = it.EMP_NRSERIE.toString()
                o.EMP_FTP = it.EMP_FTP.toString()
                o.EMP_BANVERSAO = it.EMP_BANVERSAO.toString()
                o.EMP_WEBVERSAO = it.EMP_WEBVERSAO.toString()
                o.EMP_SERVERFTP = it.EMP_SERVERFTP.toString()
                o.EMP_URLPRO00 = it.EMP_URLPRO.toString()
                o.EMP_CIDADE = it.EMP_CIDADE.toString()
                o.EMP_CONFQTNOTAOK = it.EMP_CONFQTNOTAOK.toString()
                o.EMP_NRSERIE = it.EMP_NRSERIE.toString()
                lObj.add(o)
            }

        }
        //println("aqui lObj")
        //println(lObj)
        return lObj
    }

     */

    fun construtorLista(_it: XMLHttpRequest): ArrayList<Logon> {

        val lObj = ArrayList<Logon>()

        try {

            if (!_it.responseText.equals(null) && !_it.responseText.equals("")) {

                val lista = JSON.parse<Array<dynamic>>(_it.responseText)
                ff.println0("zuza124 " + _it.responseText)
                lista.forEach {

                    val o = Logon()
                    o.G1 = it.G1
                    o.G2 = it.G2
                    o.G3 = it.G3
                    o.G4 = it.G4
                    o.G5 = it.G5
                    o.G6 = it.G6
                    o.G7 = it.G7
                    o.G8 = it.G8
                    o.G9 = it.G9
                    o.aaGenericoEmp = it.aaGenericoEmp
                    console.log(o)
                    lObj.add(o)
                }

            }
            //println("aqui lObj")
            //println(lObj)
        } catch (e: Exception) {
            ff.println0("Falha na construção da lista")
            ff.println0(_it.responseText)
        }
        return lObj
    }

    open class LogonLoja {
        var ID_EMPRESA = 0
        var EMP_SERIE = 0
        var CLI_CODIGO = 0
        var PRO_CODIGO = 0
    }

    open class AdmRet {
        var EMPRESA2: String = ""
        var LOGON: String = ""
        var SENHA: String = ""
        var OBS: String = ""
        var CHAVE: String = ""

        var EMPRESA: Empresa? = null
        var EMP_SERIE = 0
        //var FUNC_EMPRESA = 0
        var FUNC_FUNCAO = ""
        var FUNC_NOME = ""
        var FUNC_TRANSPDOM00 = ""
        var FUNC_URLLOGON = ""
        var EMP_URLPRO00 = ""
        var ID_FUNCIONARIO = 0
        var GSDESENVOLVEDOR = ""
        var GSCANVIEW = ""
        var GSLOGONSIS = "" //armazena o tipo de sistema ADM - RET - FOR
        var GSLOGONFOR = "" //armazena o código do fornecedor/fabricante
        var PRO_CODIGO = ""
        var CLI_CODIGO = ""

        var OO_ADMRET = ff.gsAdmRet

        fun construtorLista(it: String): List<Logon.AdmRet> {

            var iLinha = 0
            val lObj = ArrayList<Logon.AdmRet>()

            try {
                ff.println0("zuza122 aqui")
                //ff.println0(it.responseText.toString())

                if ((!it.equals(null)) && (!it.equals(""))) {
                    var sTeste = it
                    if (sTeste.ffCopy(1, 1).equals("{")) //adicionado pois viria apenas 1 objeto
                        sTeste = "[$sTeste]"
                    val lista = JSON.parse<Array<dynamic>>(sTeste)

                    lista.forEach {
                        val o = Logon.AdmRet()
                        o.CHAVE = it.CHAVE.toString()
                        o.EMPRESA2 = it.EMPRESA2.toString()
                        o.LOGON = it.LOGON.toString()
                        o.SENHA = it.SENHA.toString()
                        o.OBS = it.OBS.toString()
                        o.GSDESENVOLVEDOR = it.GSDESENVOLVEDOR.toString()

                        o.EMPRESA = it.EMPRESA
                        o.EMPRESA!!.EMP_WEBVERSAO = it.EMPRESA!!.EMP_WEBVERSAO.toString()
                        o.EMP_SERIE = it.EMP_SERIE.toString().ffVsi()

                        //o.FUNC_EMPRESA = it.FUNC_EMPRESA.toString().ffVsi()
                        o.FUNC_FUNCAO = it.FUNC_FUNCAO.toString()
                        o.FUNC_NOME = it.FUNC_NOME.toString()
                        o.FUNC_TRANSPDOM00 = it.FUNC_TRANSPDOM00.toString()
                        o.FUNC_URLLOGON = it.FUNC_URLLOGON.toString()
                        o.ID_FUNCIONARIO = it.ID_FUNCIONARIO.toString().ffVsi()

                        o.GSCANVIEW = it.GSCANVIEW.toString()
                        o.GSLOGONSIS = it.GSLOGONSIS.toString()
                        o.GSLOGONFOR = it.GSLOGONFOR.toString()

                        o.OO_ADMRET = it.OO_ADMRET.toString()

                        lObj.add(o)
                    }
                }
            } catch (e: Exception) {
                ff.println0("Falha na construção da lista")
                ff.println0(it)
            }
            return lObj
        }

    }
}

